module.exports = __webpack_public_path__ + "static/ishi-cover-bg-dd2a75563c193fe62bd85bd25a8a8412.png";